import { PIcon } from '@porsche-design-system/components-react';
import FixedRangePicker, { type FixedRangePickerFieldProps } from '../../../components/fields/FixedRangePickerField';
import CalendarIcon from '../../../icons/mobility/calendar.svg';
import { FixedRangePickerContainer } from './shared';

const FixedRangePickerField = (props: FixedRangePickerFieldProps) => (
    <FixedRangePickerContainer>
        <FixedRangePicker
            {...props}
            errorIcon={
                <PIcon aria={{ 'aria-label': 'Exclamation icon' }} color="notification-error" name="exclamation" />
            }
            suffixIcon={<CalendarIcon />}
        />
    </FixedRangePickerContainer>
);

export default FixedRangePickerField;
